import { createUseStyles } from 'react-jss'

export const useCustomAxisStyles = createUseStyles({
  axisContainer: {
    width: '100%',
    padding: '8px 0',
    borderColor: props => props.color,
    backgroundColor: '#fff',
    zIndex: 10,
    position: 'relative',
    boxSizing: 'border-box'
  },
  scaleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    height: 25,
    // Match the chart's actual plotting area width and position (canvas is split between Y-labels and data area)
    width: props => (props.chartAreaDimensions ? `${props.chartAreaDimensions.width}px` : '100%'),
    marginLeft: props => (props.chartAreaDimensions ? `${props.chartAreaDimensions.left}px` : 0)
  },
  scaleLine: {
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    height: 1,
    backgroundColor: props => props.color,
    opacity: 0.2
  },
  scaleMarker: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1
  },
  tick: {
    width: 1,
    height: 6,
    backgroundColor: props => props.color,
    marginBottom: 3
  },
  tickLabel: {
    fontSize: 11,
    color: props => props.color,
    fontWeight: 500,
    whiteSpace: 'nowrap'
  }
})
